import { createSlice } from '@reduxjs/toolkit';
import { RequestStatus } from '../../../interface';
import { getDefaultHomeThunk } from '../thunks/default-home.thunk';
export const defaultHomeSliceName = 'defaultHome';
export const initialDefaultHomeState = {
  status: RequestStatus.IDLE,
  error: null
};
export const {
  reducer: defaultHomeReducer,
  actions: defaultHomeActions
} = createSlice({
  name: defaultHomeSliceName,
  initialState: initialDefaultHomeState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getDefaultHomeThunk.pending, state => {
      state.status = RequestStatus.LOADING;
    });
    builder.addCase(getDefaultHomeThunk.fulfilled, (state, action) => Object.assign({}, state, {
      status: RequestStatus.SUCCESS,
      homeKey: action.payload,
      error: null
    }));
    builder.addCase(getDefaultHomeThunk.rejected, (state, action) => Object.assign({}, state, {
      status: RequestStatus.ERROR,
      homeKey: null,
      error: action.error
    }));
  }
});